// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__PCg6p","animloader":"Loader_animloader__fnDdd"};